module.exports = __webpack_public_path__ + "static/L2_visual_5_1_do-1fb10bb06f7b2c425576beb2b72fd7f7.png";